import { GeoJsonLayer } from '@deck.gl/layers'
import DeckGL from '@deck.gl/react'
import { prop } from '@soltalabs/ramda-extra'
import React from 'react'
import { useSelector } from 'react-redux'

import { getSelectedForecast } from '../../../modules/forecast'

import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'

function ForecastLayers({ viewport }) {
  const selectedForecast = useSelector(getSelectedForecast)

  if (!selectedForecast) {
    return null
  }

  const layers = [
    new GeoJsonLayer({
      id: 'geojson-layer',
      data: prop('geojson', selectedForecast),
      pickable: true,
      stroked: false,
      filled: true,
      extruded: false,
      lineWidthScale: 20,
      lineWidthMinPixels: 2,
      getFillColor: () => [92, 187, 219, 153],
    }),
  ]

  return <DeckGL viewState={viewport} layers={layers} />
}

export { ForecastLayers }
